import TrueFocus from "./ScanningLogo";
import Logo from "../assets/mercedes-benz-logo.jpg";

import FadeContent from "../fx/Fade";

function HomePage({ onStartScanning }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: "#000000",
        color: "white",
        margin: 0,
        padding: 0,
        position: "fixed",
        top: 0,
        left: 0,
      }}
    >
      <div style={{ textAlign: "center", padding: "0 1rem" }}>
        <FadeContent
          blur={true}
          duration={1000}
          easing="ease-out"
          initialOpacity={0}
        >
          <img
            src={Logo}
            alt="Logo"
            style={{
              width: "clamp(120px, 30vw, 200px)",
              marginBottom: "clamp(1.5rem, 5vw, 2rem)",
            }}
          />
          {/* Anything placed inside this container will be fade into view */}

          {/* Animated Logo */}
          <div style={{ marginBottom: "clamp(3rem, 8vw, 6rem)" }}>
            <TrueFocus
              sentence="Draw your own Mercedes"
              manualMode={false}
              blurAmount={9}
              borderColor="#00ccffff"
              animationDuration={0.8}
              pauseBetweenAnimations={0.5}
              fontSize="clamp(2rem, 8vw, 6rem)"
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button
              onClick={onStartScanning}
              style={{
                padding: "clamp(0.875rem, 3vw, 1.25rem) clamp(2rem, 5vw, 3rem)",
                fontSize: "clamp(1rem, 3.5vw, 1.5rem)",
                cursor: "pointer",
                backgroundColor: "#00ccffff",
                color: "black",
                border: "none",
                borderRadius: "12px",
                boxShadow: "0 4px 8px rgba(0, 204, 255, 0.3)",
                transition: "all 0.3s ease",
                fontWeight: "bold",
                minWidth: "160px",
                maxWidth: "90vw",
                touchAction: "manipulation",
                WebkitTapHighlightColor: "transparent",
              }}
              onTouchStart={(e) => {
                e.currentTarget.style.transform = "scale(0.95)";
              }}
              onTouchEnd={(e) => {
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              Start
            </button>
          </div>
        </FadeContent>
      </div>
    </div>
  );
}

export default HomePage;
